import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row d-flex justify-content-center"
}
const _hoisted_2 = { class: "col-1 mt-3 mb-3" }
const _hoisted_3 = { class: "progress-spinner progress-spinner-double size-sm progress-spinner-active" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "progress-spinner-inner" }, null, -1)
const _hoisted_6 = { class: "visually-hidden" }
const _hoisted_7 = {
  key: 1,
  class: "row justify-content-center"
}
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = {
  key: 2,
  class: "row justify-content-center"
}
const _hoisted_10 = { class: "col-12 text-center" }
const _hoisted_11 = ["onClick"]

import { onMounted, ref, inject, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "../../models/Store/store";
import api from "@/services/BookingService";
import _ from "lodash";
import { useI18n } from "vue-i18n";
import constants from "@/models/Utils/constants";
import { useTenantConfig } from "@/composables/useTenantConfig";


export default /*#__PURE__*/_defineComponent({
  __name: 'Municipality',
  setup(__props) {

const router = useRouter();
const store = useStore();
const { t } = useI18n();
const emitter = inject("emitter");
const tenantConfig = useTenantConfig();

const selectedItem = ref(null);
const loading = ref(false);
const municipalities = ref([]);

onMounted(() => {
  store.stepsMade.municipality = null;

  emitter.on(constants.GO_NEXT_STEP, () => {
    console.log("received goNextStep Municipality");
    goToNextStep();
  });
  getData();
});

watch(
  () => selectedItem.value,
  (newVal) => {
    if (newVal) {
      emitter.emit(constants.CAN_GO_NEXT_STEP, true);
    } else {
      emitter.emit(constants.CAN_GO_NEXT_STEP, false);
    }
  },
  { immediate: true }
);

const getData = () => {
  loading.value = true;

  const serviceIds: number[] = [];
  if (store.stepsMade && store.stepsMade.service) {
    serviceIds.push(parseInt(store.stepsMade.service.id));
  }

  api
    .getMunicipality(store.tenantSelected.id, serviceIds)
    .then((result) => {
      if (_.isNull(result) === false && _.isUndefined(result) === false) {
        if (
          _.isNull(result.data) === false &&
          _.isUndefined(result.data) === false &&
          _.isArray(result.data.municipalities)
        ) {
          const response = result.data;
          municipalities.value = response.municipalities;
        }
      }

      loading.value = false;
    })
    .catch((err: any) => {
      console.log("Errore nella get dei comuni");
      console.log(err);
      loading.value = false;
    });
};

const setMunicipality = (municipality: string) => {
  selectedItem.value = municipality;
};

const goToNextStep = () => {
  store.stepsMade.municipality = selectedItem.value;
  const locationRouteSelection = tenantConfig.getRouteNameLocationSelection();
  router.push({ name: locationRouteSelection });
};

const bookEditHasSameMunicipality = (municipality: string) => {
  if (
    _.isNull(store.bookedit) === false &&
    store.bookedit.room &&
    store.bookedit.room.location &&
    store.bookedit.room.location.city
  ) {
    if (store.bookedit.room.location.city === municipality) {
      return true;
    }
  }
  return false;
};

return (_ctx: any,_cache: any) => {
  return (loading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _hoisted_5,
            _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(t)("common.loadingText")), 1)
          ])
        ])
      ]))
    : (municipalities.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, _toDisplayString(_unref(t)("titles.noMunicipalityFound")), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h2", null, _toDisplayString(_unref(t)("titles.selectBookingMunicipality")), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(municipalities.value, (municipality, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "col-12 col-md-6 col-lg-4 d-grid gap-2",
              key: index
            }, [
              _createElementVNode("button", {
                type: "button",
                class: _normalizeClass(["btn btn-primary btn-lg my-3", [
          bookEditHasSameMunicipality(municipality) ? 'editPreviousChoice' : '',
        ]]),
                onClick: ($event: any) => (setMunicipality(municipality))
              }, _toDisplayString(municipality), 11, _hoisted_11)
            ]))
          }), 128))
        ]))
}
}

})